import { render, staticRenderFns } from "./TxTableModal.vue?vue&type=template&id=27624554&"
import script from "./TxTableModal.vue?vue&type=script&lang=js&"
export * from "./TxTableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports